export default __webpack_public_path__ + "static/media/head02_th_pc@2x.08ad51e1.png";